var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height:'700px',width:'100%'}),attrs:{"id":"myChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }